<template>
  <div
    :class="{'shorttag-update-btn': btnType === 'update'}"
  >
    <b-button
      variant="light"
      @click="openModal"
    >
      <template v-if="btnType === 'update'">
        {{ $t('tiptap:btn.edit') }} edit
      </template>
      <template v-else>
        {{ $t('tiptap:contentLinkList.title') }}
      </template>
    </b-button>
    <modal
      :name="modalName"
      :scrollable="true"
      height="auto"
      width="600px"
      @close="closeModal"
    >
      <b-button
        class="modal-close"
        variant="light"
        @click="closeModal"
      >
        <i class="icon"><icon-times /></i>
      </b-button>
      <div class="modal-header">
        <h4 class="text-center mb-4">
          {{ $t('tiptap:contentLinkList.title') }}
        </h4>
      </div>
      <div class="modal-body m-4">
        <div class="container">
          <div class="form-group">
            <b-form-input
              v-model="linkListTitle"
              :placeholder="$t('tiptap:contentLinkList.headline')"
              type="text"
            />
          </div>
          <div class="form-group">
            <b-form-select
              v-model="linkListTitleClass"
              :options="linkListTitleClassSelect"
            />
          </div>
          <div class="form-group">
            <b-form-select
              v-model="linkListTitleHeadingType"
              :options="linkListTitleHeadingTypeSelect"
            />
          </div>
          <div
            v-for="(linkData, linkNumber) in linkListData"
            :key="linkNumber"
            class="row"
          >
            <div class="col-4">
              <div class="form-group">
                <b-form-input
                  v-model="linkData.title"
                  :placeholder="$t('tiptap:contentLinkList.items.title')"
                  type="text"
                />
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <b-form-input
                  v-model="linkData.href"
                  :placeholder="$t('tiptap:contentLinkList.items.href')"
                  type="text"
                />
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <b-form-input
                  v-model="linkData.img"
                  :placeholder="$t('tiptap:contentLinkList.items.img')"
                  type="text"
                />
              </div>
            </div>
          </div>
          <b-button
            class="btn btn-secondary mr-2"
            @click.prevent="emitData(btnType)"
          >
            {{ $t('tiptap:btn.ok') }}
          </b-button>
          <b-button
            class="btn btn-secondary"
            @click.prevent="appendLinkListEntry"
          >
            {{ $t('tiptap:btn.append') }}
          </b-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { BFormInput, BFormSelect, BButton } from 'bootstrap-vue';
import IconTimes from 'ICON:IconTimes';

export default ({
  name: 'ContentLinkListBtn',
  components: {
    BFormInput,
    BFormSelect,
    BButton,
    IconTimes,
  },
  props: {
    // button can insert new or update existing shorttag
    btnType: {
      type: String,
      default: 'insert',
    },
    linkListTitleProp: {
      type: String,
      default: '',
    },
    linkListTitleClassProp: {
      type: String,
      default: 'text-center',
    },
    linkListTitleHeadingTypeProp: {
      type: String,
      default: '',
    },
    linkListDataProp: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // modal name has to be unique
      modalName: `contentLinkListBtnModal_${this.btnType}_${Math.floor(Math.random() * 1000)}`,
      linkListTitle: '',
      linkListTitleClass: '',
      linkListTitleClassSelect: [
        { value: 'text-left', text: this.$t('tiptap:contentLinkList.headingselect.left') },
        { value: 'text-center', text: this.$t('tiptap:contentLinkList.headingselect.center') },
        { value: 'text-right', text: this.$t('tiptap:contentLinkList.headingselect.right') },
      ],
      linkListTitleHeadingType: '',
      linkListTitleHeadingTypeSelect: [
        { value: '', text: this.$t('tiptap:contentLinkList.headingtype.title') },
        { value: 'p', text: 'p' },
        { value: 'h1', text: 'h1' },
        { value: 'h2', text: 'h2' },
        { value: 'h3', text: 'h3' },
        { value: 'h4', text: 'h4' },
        { value: 'h5', text: 'h5' },
        { value: 'h6', text: 'h6' },
      ],
      linkListDataTemplate: { title: '', href: '', img: '' },
      linkListData: [
        { title: '', href: '', img: '' },
      ],
    };
  },
  methods: {
    closeModal() {
      this.linkListTitle = '';
      this.linkListTitleClass = 'text-center';
      this.linkListTitleHeadingType = '';
      this.linkListData = [
        { ...this.linkListDataTemplate },
      ];
      this.$modal.hide(this.modalName);
    },
    emitData() {
      this.$emit(`${this.btnType}-content`, {
        type: 'ContentLinkListShorttag',
        attrs: {
          listTitle: this.linkListTitle,
          listTitleClass: this.linkListTitleClass,
          listTitleHeadingType: this.linkListTitleHeadingType,
          listElements: this.linkListData,
        },
      });
      this.closeModal();
    },
    appendLinkListEntry() {
      this.linkListData.push({ ...this.linkListDataTemplate });
    },
    openModal() {
      this.linkListTitle = this.linkListTitleProp ? this.linkListTitleProp : '';
      this.linkListTitleClass = this.linkListTitleClassProp ? this.linkListTitleClassProp : 'text-center';
      this.linkListTitleHeadingType = this.linkListTitleHeadingTypeProp ? this.linkListTitleHeadingTypeProp : '';
      this.linkListData = this.linkListDataProp.length ?
        [...this.linkListDataProp] :
        [{ ...this.linkListDataTemplate }];
      this.$modal.show(this.modalName);
    },
  },
});
</script>
